import React from 'react'
import { Circles } from 'react-loader-spinner'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { getBreakUpDetails } from '../../utils/helper'

function ListingDataComp(props) {
    const { loader, paymentData } = props
    return (
        <div className='ms-0 me-0'>
            {(loader) ? <div className='d-flex justify-content-center align-items-center'> <Circles
                height="20"
                width="20"
                style={{ display: 'inline-block' }}
                color="#26A8E0"
                ariaLabel="circles-loading"
                visible={true}
            /></div> : getBreakUpDetails(paymentData)?.length > 0 && (!loader) ? <div>
                {getBreakUpDetails(paymentData)?.map((listItem, listIndex) => {
                    return <div key={listIndex} className='row'>
                        {listItem?.extraParam == 1 ? 
                                <small className="text-danger small col-8 d-block"><span className="text-danger small d-block p-0 m-0">{listItem?.headerName}</span></small>
                            :
                        <>
                                <span className='col-8'>{listItem?.headerName}</span>
                                <span className="text-end col-4">{listItem?.id === 0 ? `$${listItem?.val}` : listItem?.val}
                                </span>                            
                        </>}
                        {/* <span className='col-8'>{listItem?.headerName}</span>
                        <span className="text-end col-4">{listItem?.id === 0 ? `$${listItem?.val}` : listItem?.val}</span> */}
                    </div>
                })}
            </div> : null}
        </div>
    )
}

ListingDataComp.propTypes = {
    dispatch: PropTypes.func,
    paymentData: PropTypes.object,
    loader: PropTypes.bool
}

ListingDataComp.defaulProps = {
    dispatch: noop,
    paymentData: EMPTY_OBJECT,
    loader: false
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ListingDataComp)